/**
 * Created by stone.
 *
 */
import api from './index'

// 数据列表
const dataList = (listpath, pageNumber, pageSize, filterForm) =>
  api.get(listpath, {
    params: {
      pageNumber,
      pageSize,
      ...filterForm
    }
  })

// 详情
const item = (path, id) =>
  api.get(path, {
    params: {
      id
    }
  })

// 删除
const dataDelete = (delpath, id) =>
  api.delete(delpath, {
    params: {
      id
    }
  })

// 批量删除
const batchDelete = (batchDelpath, ids) =>
  api.get(batchDelpath, {
    params: {
      ids
    }
  })

// 批量ids
const batchIds = (path, ids, status) =>
  api.get(path, {
    params: {
      ids,
      status
    }
  })

// 修改
const dataUpdate = (updatepath, form) =>
  api.post(updatepath, {
    ...form
  })

// 审批
const dataAudit = (auditpath, form) =>
  api.post(auditpath, {
    ...form
  })

// get无参数
const getNoParams = (path) => api.get(path)

// GET请求参数
const queryGet = (getPath, name) =>
  api.get(getPath, {
    params: {
      name
    }
  })

// 新增/编辑 id: 当接口为更新时不为空
const toEdit = (path, id) =>
  api.get(path, {
    params: {
      id
    }
  })

const getorderId = (path, orderId) =>
  api.get(path, {
    params: {
      orderId
    }
  })

// 修改状态 0-初始化 1-启用 2-停用

const statusEdit = (path, id, status) =>
  api.get(path, {
    params: {
      id,
      status
    }
  })

// // 数据字典
const getDic = (name) =>
  api.get('/v1/sysDic/get', {
    params: {
      name
    }
  })

// postForm
const postForm = (path, form) =>
  api.post(path,
    form
  )

// 新增/编辑 id: 当接口为更新时不为空
const getList = (path, form) =>
  api.get(path, {
    params: {
      ...form
    }
  })

// 新增/编辑 id: 当接口为更新时不为空
const getForm = (path, form) =>
  api.get(path, {
    params: {
      ...form
    }
  })

// 查询数据字典，参数typeId说明：D01:省市，D02：部门、职务，D03：单位类型，D04：性别，D05：证件类型，D06：学历，D07:学位
const getComboxDatasById = (typeId) =>
  api.get('/api/services/app/Combox/GetComboxDatasById', {
    params: {
      typeId
    }
  })

// 新增数据字典，参数dictTypeId说明：D01:省市，D02：部门、职务，D03：单位类型，D04：性别，D05：证件类型，D06：学历，D07:学位
const addComboxDatasById = (dictTypeId, itemName) =>
  api.post('/api/services/app/Combox/GetComboxDatasById', {
    params: {
      dictTypeId,
      itemName
    }
  })

// 查询数据字典数组，typeIdArray格式：D08;D09
const getComboxDatasByIdArray = (typeIdArray) => {
  if (!typeIdArray) {
    typeIdArray = ''
  }
  var tempArray = typeIdArray.split(';')
  let tempJsonStr = ''

  for (let i = 0; i < tempArray.length; i++) {
    if (i === tempArray.length - 1) {
      tempJsonStr += 'typeIdArray=' + tempArray[i]
    } else {
      tempJsonStr += 'typeIdArray=' + tempArray[i] + '&'
    }
  }

  return api.get('/api/services/app/Combox/GetComboxDatasByIdArray?' + tempJsonStr)
}

// 根据数据字典过滤数据
const comBoxDataFilter = (data, typeId) => {
  var tempArr = []

  for (let i = 0; i < data.length; i++) {
    const id = data[i].typeId

    if (id === typeId) {
      tempArr.push(data[i])
    }
  }

  return tempArr
}

const downloadFile = (url, id) => {
}

const getKetiInfo = (moduleCode, moduleKey) => {
  var path = '/api/services/app/Com/GetKetiOtherInfo?moduleCode=' + moduleCode + '&moduleKey=' + moduleKey
  return api.get(path)
}
export default {
  dataList,
  dataDelete,
  batchDelete,
  dataUpdate,
  dataAudit,
  queryGet,
  item,
  getNoParams,
  postForm,
  getDic,
  statusEdit,
  toEdit,
  getForm,
  getList,
  batchIds,
  getorderId,
  getComboxDatasById,
  addComboxDatasById,
  getComboxDatasByIdArray,
  comBoxDataFilter,
  downloadFile,
  getKetiInfo
}
